"use client";

import { useCallback, useEffect, useState } from "react";

import { useAuth } from "@/contexts/AuthContext";
import { type SearchQueryItem, getUserSearchQueries } from "@/lib/shop-agent-client";

/** The navbar's search parameters, applied to every later search. */
export interface ActiveSearchParams {
  gender: "women" | "men" | "kids" | "all";
  size?: string;
}

/** Recent searches and the navbar's search parameters, shared across the app. */
export function useSearch() {
  const { userId } = useAuth();
  // Recent search queries (persisted for recovery)
  const [recentSearches, setRecentSearches] = useState<SearchQueryItem[]>([]);
  const [activeSearchParams, setActiveSearchParams] = useState<ActiveSearchParams>({
    gender: "women", // Default to women
  });

  // Load recent searches on mount
  useEffect(() => {
    if (userId) {
      getUserSearchQueries(50)
        .then((data) => {
          setRecentSearches(data.queries);
        })
        .catch((err) => {
          console.error("Failed to load recent searches:", err);
        });
    }
  }, [userId]);

  // Update individual search parameter
  const updateSearchParam = useCallback(
    <K extends keyof ActiveSearchParams>(key: K, value: ActiveSearchParams[K]) => {
      setActiveSearchParams((prev) => ({ ...prev, [key]: value }));
    },
    []
  );

  return { recentSearches, activeSearchParams, updateSearchParam };
}
